import { useState, useEffect, useMemo } from 'react';

interface LiteModeState {
  /** Lite mode Р°РєС‚РёРІРµРЅ - РѕС‚РєР»СЋС‡Р°РµРј С‚СЏР¶С‘Р»С‹Рµ СЌС„С„РµРєС‚С‹ */
  isLiteMode: boolean;
  /** РџРѕР»СЊР·РѕРІР°С‚РµР»СЊ РїСЂРµРґРїРѕС‡РёС‚Р°РµС‚ reduced motion */
  prefersReducedMotion: boolean;
  /** РњРѕР±РёР»СЊРЅРѕРµ СѓСЃС‚СЂРѕР№СЃС‚РІРѕ */
  isMobile: boolean;
  /** Low-end СѓСЃС‚СЂРѕР№СЃС‚РІРѕ (РјР°Р»Рѕ РїР°РјСЏС‚Рё, СЃР»Р°Р±С‹Р№ CPU) */
  isLowEnd: boolean;
  /** Telegram WebView */
  isTelegramWebView: boolean;
}

/**
 * РҐСѓРє РґР»СЏ РѕРїСЂРµРґРµР»РµРЅРёСЏ РЅРµРѕР±С…РѕРґРёРјРѕСЃС‚Рё "РѕР±Р»РµРіС‡С‘РЅРЅРѕРіРѕ" СЂРµР¶РёРјР°
 * РЈС‡РёС‚С‹РІР°РµС‚:
 * - prefers-reduced-motion
 * - Telegram WebView РЅР° РјРѕР±РёР»СЊРЅС‹С…
 * - Low-end СѓСЃС‚СЂРѕР№СЃС‚РІР° (hardwareConcurrency, deviceMemory)
 * - Р Р°Р·РјРµСЂ СЌРєСЂР°РЅР°
 */
export function useLiteMode(): LiteModeState {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  // РћРїСЂРµРґРµР»СЏРµРј СЃС‚Р°С‚РёС‡РµСЃРєРёРµ Р·РЅР°С‡РµРЅРёСЏ РѕРґРёРЅ СЂР°Р·
  const staticValues = useMemo(() => {
    if (typeof window === 'undefined') {
      return {
        isMobile: false,
        isLowEnd: false,
        isTelegramWebView: false,
      };
    }

    const isMobile = window.innerWidth < 768 || 
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // РџСЂРѕРІРµСЂСЏРµРј Telegram WebView
    const isTelegramWebView = Boolean(
      (window as any).Telegram?.WebApp || 
      navigator.userAgent.includes('Telegram') ||
      window.location.href.includes('tgWebAppData')
    );

    // РћРїСЂРµРґРµР»СЏРµРј low-end СѓСЃС‚СЂРѕР№СЃС‚РІРѕ
    const nav = navigator as any;
    const hardwareConcurrency = nav.hardwareConcurrency || 4;
    const deviceMemory = nav.deviceMemory || 4; // GB
    
    // Low-end: <= 4 СЏРґСЂР° РёР»Рё <= 4GB RAM
    const isLowEnd = hardwareConcurrency <= 4 || deviceMemory <= 4;

    return {
      isMobile,
      isLowEnd,
      isTelegramWebView,
    };
  }, []);

  // РЎР»СѓС€Р°РµРј РёР·РјРµРЅРµРЅРёСЏ prefers-reduced-motion
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  // Lite mode Р°РєС‚РёРІРµРЅ РµСЃР»Рё:
  // 1. РџРѕР»СЊР·РѕРІР°С‚РµР»СЊ РїСЂРµРґРїРѕС‡РёС‚Р°РµС‚ reduced motion
  // 2. Telegram WebView РЅР° РјРѕР±РёР»СЊРЅРѕРј СѓСЃС‚СЂРѕР№СЃС‚РІРµ
  // 3. Low-end СѓСЃС‚СЂРѕР№СЃС‚РІРѕ
  const isLiteMode = useMemo(() => {
    return prefersReducedMotion || 
           (staticValues.isTelegramWebView && staticValues.isMobile) ||
           (staticValues.isLowEnd && staticValues.isMobile);
  }, [prefersReducedMotion, staticValues]);

  return {
    isLiteMode,
    prefersReducedMotion,
    ...staticValues,
  };
}

/**
 * РљРѕРЅС‚РµРєСЃС‚ РґР»СЏ РіР»РѕР±Р°Р»СЊРЅРѕРіРѕ РґРѕСЃС‚СѓРїР° Рє lite mode
 * РСЃРїРѕР»СЊР·СѓРµС‚СЃСЏ РґР»СЏ РёР·Р±РµР¶Р°РЅРёСЏ РјРЅРѕР¶РµСЃС‚РІРµРЅРЅС‹С… РІС‹Р·РѕРІРѕРІ С…СѓРєР°
 */
import { createContext, useContext, ReactNode } from 'react';

const LiteModeContext = createContext<LiteModeState | null>(null);

export function LiteModeProvider({ children }: { children: ReactNode }) {
  const liteModeState = useLiteMode();
  
  return (
    <LiteModeContext.Provider value={liteModeState}>
      {children}
    </LiteModeContext.Provider>
  );
}

export function useLiteModeContext(): LiteModeState {
  const context = useContext(LiteModeContext);
  if (!context) {
    // Fallback РµСЃР»Рё РїСЂРѕРІР°Р№РґРµСЂ РЅРµ СѓСЃС‚Р°РЅРѕРІР»РµРЅ
    return {
      isLiteMode: false,
      prefersReducedMotion: false,
      isMobile: false,
      isLowEnd: false,
      isTelegramWebView: false,
    };
  }
  return context;
}

/**
 * РҐРµР»РїРµСЂ РґР»СЏ РѕРїСЂРµРґРµР»РµРЅРёСЏ, РЅСѓР¶РЅРѕ Р»Рё Р°РЅРёРјРёСЂРѕРІР°С‚СЊ
 * РСЃРїРѕР»СЊР·СѓРµС‚СЃСЏ РІРѕ РІСЃРµС… РєРѕРјРїРѕРЅРµРЅС‚Р°С… СЃ С‚СЏР¶С‘Р»С‹РјРё Р°РЅРёРјР°С†РёСЏРјРё
 */
export function useShouldAnimate(): boolean {
  const { isLiteMode, prefersReducedMotion } = useLiteModeContext();
  return !isLiteMode && !prefersReducedMotion;
}

/**
 * Р’РѕР·РІСЂР°С‰Р°РµС‚ РѕР±СЉРµРєС‚ СЃ РЅР°СЃС‚СЂРѕР№РєР°РјРё Р°РЅРёРјР°С†РёРё РґР»СЏ framer-motion
 * Р’ lite mode РІРѕР·РІСЂР°С‰Р°РµС‚ РїСѓСЃС‚С‹Рµ/РјРёРЅРёРјР°Р»СЊРЅС‹Рµ Р°РЅРёРјР°С†РёРё
 */
export function useAnimationConfig() {
  const shouldAnimate = useShouldAnimate();
  
  return {
    shouldAnimate,
    // Hover/tap Р°РЅРёРјР°С†РёРё
    hoverScale: shouldAnimate ? { scale: 1.02 } : {},
    tapScale: shouldAnimate ? { scale: 0.98 } : {},
    // Page transitions
    pageTransition: shouldAnimate 
      ? { type: "spring", stiffness: 300, damping: 30 }
      : { duration: 0.15 },
    // Fade variants
    fadeVariants: shouldAnimate 
      ? {
          initial: { opacity: 0, y: 10 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: -10 },
        }
      : {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
        },
    // Р”Р»СЏ AnimatePresence - РІ lite mode РѕС‚РєР»СЋС‡Р°РµРј
    animatePresenceMode: shouldAnimate ? 'wait' as const : 'sync' as const,
  };
}
